import React from 'react';

const SvgBellAlarm = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M12 2a1.5 1.5 0 00-1.5 1.5v.695A5.997 5.997 0 006 10v6l-2 2v1h16v-1l-2-2v-6a5.997 5.997 0 00-4.5-5.805V3.5A1.5 1.5 0 0012 2zm-6.092.082C3.535 3.91 2 6.772 2 10h2a7.978 7.978 0 013.127-6.334L5.908 2.082zm12.184 0l-1.219 1.584A7.978 7.978 0 0120 10h2c0-3.228-1.535-6.09-3.908-7.918zM10 20c0 1.1.9 2 2 2s2-.9 2-2h-4z" />
  </svg>
);

export default SvgBellAlarm;
